import React from 'react';
import {Provider} from 'react-redux'
import {store} from "./common/redux/store";
import {AppProvider} from "./common/providers/app.provider";

function App() {
    return (
        <div className="App">
            <Provider store={store}>
                <AppProvider />
            </Provider>
        </div>
    );
}

export default App;
